import { Injectable } from '@angular/core';

import { HttpClient } from './../http-client';
import { Config } from '../local/config';
import { UserData } from '../local/user-data';

/*
  Generated class for the UserProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UserProvider {

  constructor(public http: HttpClient,
    public userData: UserData,
    public config: Config) {
    console.log('Hello UserProvider Provider');
  }


  getSupervising() {
    let user = this.userData.user;
    if(!user) {
      return Promise.reject({
        status: 'error',
        message: 'Error'
      });
    }
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/users/supervising/${user.id}`;

    return this.http.get(link, 1);
  }

  getOperatorsWithCredits() {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/alfa/reports`;
    let data = {spName: "operadores_get", spParams: []};

    return this.http.post(link, data, 1)
    .then((res: any) => {
      console.log('Data Operadores_get', res.data)
      if(res && res.data && res.data.table) {
        res.data = res.data.table;

        if(res.data.length) {
          res.data.push({
            id: this.userData.user.id,
            displayName: this.userData.user.displayName
          });
        }
      }
      return res;
    });

    
  }

  managedByCurrentUser() {
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/accounts/managedByCurrentUser`;

  
    return this.http.get(link, 1)
    .then((res: any) => {
      if(res.status == 'success' && res.data && res.data.length && this.userData.user.roleId < 3) {
        //res.data.push(this.userData.user.account);
      }
      return res;
    });
  }

  transferByCurrentUser() {
   
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/accounts/transferByCurrentUser`;

    return this.http.get(link, 1);
  }

}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/providers/user/user.ts